import { render, staticRenderFns } from "./DashboardDataUsage.vue?vue&type=template&id=136e44c3&scoped=true"
import script from "./DashboardDataUsage.vue?vue&type=script&lang=js"
export * from "./DashboardDataUsage.vue?vue&type=script&lang=js"
import style0 from "./DashboardDataUsage.vue?vue&type=style&index=0&id=136e44c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e44c3",
  null
  
)

export default component.exports